/* Copyright (c) 2017 Backpack Health LLC */

import React, { SFC } from 'react'
import classnames from 'classnames';

import './Form.css';

interface Props {
  onSubmit?(): void;
  style?: object;
  hasPadding?: boolean;
}
const Form: SFC<Props> = ({ children, onSubmit, hasPadding, style }) => (
  <form
    className={classnames('cmp-form', { '__padding': hasPadding })}
    onSubmit={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onSubmit && onSubmit();
      return false;
    }}
    style={style}
  >
    {children}
  </form>
)

export default Form